import {BrowserRouter} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

import {queryClient} from '@queries/queryClient';
import {ThemeModeProvider} from '@components/ThemeModeProvider';
import {AppRouter} from '@routes/AppRouter';

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeModeProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ThemeModeProvider>
    {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-right" />}
  </QueryClientProvider>
);
